import styled, { css } from 'styled-components'
import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'

export const InfoLabel = styled.label`
  font-family: ${FONTS.bold};
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: ${COLORS.primary};
  margin-bottom: 4px;
`

export const InfoValue = styled.div`
  color: ${COLORS.navi};
  font-family: ${FONTS.medium};

  .sold-price {
    color: ${COLORS.primary};
    margin-right: 8px;

    &.mobile {
      display: none;

      @media ${DEVICES.mobile} {
        display: inline;
      }
    }
  }
`

export const Info = styled.div`
  margin-right: 60px;
  min-width: 210px;

  &:last-child {
    margin-right: 0;
  }

  ${({ highlight }) =>
    highlight &&
    css`
      ${InfoValue} {
        color: ${COLORS.primary};
      }

      @media ${DEVICES.mobile} {
        display: none !important;
      }
    `}
`

export const PriceInfo = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${COLORS.nature.base};
  padding-bottom: 18px;
  margin-bottom: 20px;

  @media ${DEVICES.mobile} {
    flex-direction: column-reverse;
    align-items: flex-start;

    ${Info} {
      display: flex;
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 1px;

      &:first-child {
        margin-bottom: 0;
      }
    }

    ${InfoLabel} {
      margin-bottom: 0;
      margin-right: 8px;
    }
  }
`

export const OtherInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  > div {
    min-width: 210px;
    margin-right: 60px;
    margin-left: 0;
  }

  @media ${DEVICES.mobile} {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0;

    > div {
      margin-bottom: 12px;

      span {
        display: inline-block;
      }
    }
  }
`

export const InfoGroup = styled.div`
  padding-bottom: 44px;

  @media ${DEVICES.mobile} {
    padding-bottom: 20px;
  }
`
